
const digest = 'ade4d2ea85f02a1751f7aaa69ddc561cf25fcb3b1c0f2488a1d3b30e38dfa4f0';
const classes = {"wrapper":"_wrapper_hgg6p_1","inputs":"_inputs_hgg6p_6","inputWrapper":"_inputWrapper_hgg6p_13","buttons":"_buttons_hgg6p_17"};
const css = `._wrapper_hgg6p_1 {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
._wrapper_hgg6p_1 ._inputs_hgg6p_6 {
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: center;
  width: 100%;
}
._wrapper_hgg6p_1 ._inputs_hgg6p_6 ._inputWrapper_hgg6p_13 {
  flex: 1;
  min-width: 0;
}
._wrapper_hgg6p_1 ._buttons_hgg6p_17 {
  display: flex;
  flex-direction: row;
  gap: 10px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  